import { useEffect } from "react";
import { useForm } from "@mantine/form";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import { Schema } from "../../../api/types";
import usePostSchema from "../../../api/usePostSchema";
import { typedSxMap } from "../../../utils/typedSxMap";

type CreateSchemaModalProps = {
  workspaceId: string;
  schema?: Schema | null;
  onSuccess: (data: any) => void;
  action: string;
};

const styles = typedSxMap({});

export default function CreateEditSchemaForm({ workspaceId, schema, onSuccess, action }: CreateSchemaModalProps) {
  const { mutate, isLoading, error, isSuccess, data } = usePostSchema(workspaceId, schema?.id);
  const form = useForm({
    initialValues: {
      id: schema?.id || "",
      name: schema?.name || "",
      workspace_id: workspaceId || "",
    },
  });

  useEffect(() => {
    if (isSuccess && !error && !isLoading) {
      onSuccess(false);
    }
  }, [isSuccess, error, isLoading]);

  const requiredFieldEmpty = form.getInputProps("name").value.length === 0;
  const handleSubmit = async (values: any) => {
    await mutate(values);
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)} aria-disabled={isLoading}>
      <Input
        name="name"
        className="nameInput"
        autoComplete="off"
        placeholder={!schema ? "Name" : `${schema?.name}`}
        {...form.getInputProps("name")}
        required
        autoFocus={!schema}
      />
      <Button type="submit" variants={["primary", "noMargin"]} disabled={isLoading || !form.isDirty() || requiredFieldEmpty}>
        {action === "Edit" ? "Save" : action}
      </Button>
    </form>
  );
}
